import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { UnitTypeUiModel } from '../../../shared/ui-models/unit-type.ui-model';
import { ChooseUnitType } from './components/choose-unit-type-modal/choose-unit-type.component';
import { ChooseAppt } from './components/choose-appt/choose-appt.component';
import {
  BookAvailabilityResponseModel,
  BookOfferResponseModel
} from '../../../shared/ui-models/book.ui-model';
import {
  getBookAvailability,
  getBookOffer,
  createReservation,
  creatBlockDates
} from '../../shared/services/data.service';
import { PaymentDetails } from './components/payment-details/payment-details.component';
import { AddGuest } from './components/add-guest/add-guest.component';
import Select, { ValueType } from 'react-select';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../shared/components/core-ui/button/button.component';
import { CreateReservationRequestModel } from '../../../shared/models/reservation.model';
import moment from 'moment';
import { CreateBlockDatesModel } from '../../../shared/models/block-dates.model';
import { TextArea } from '../../../shared/components/core-ui/text-area/text-area.component';
import { ReservationType } from '../../../shared/enums/reservation-type';
import { ReservationMode } from '../../../shared/enums/reservation-mode.enum';
import { UnitTypeGroupUiModel } from '../../../shared/ui-models/unit-type-group.ui-model';
import { ReservationChannel } from '../../../shared/enums/reservation-channel.enum';
import ReCAPTCHA from 'react-google-recaptcha';
import { GOOGLE_CAPTCHA_KEY } from '../../../shared/config/routes-config';
import { ReservationSource } from '../../../shared/enums/reservation-souce.enum';
import { ReservationTypeOfStay } from '../../../shared/enums/reservation-type-of-stay.enum';

import { AssignSalesPersonModal } from '../../../UnitTypeModule/containers/unit-types-list/components/assign-salesPerson-modal/assign-salesPerson-modal.component';
import Modal from '../../../ui/Model';
import { birdToast } from '../../../shared/components/core-ui/toast';
import { CompanyUiModel } from '../../../shared/ui-models/company.ui-model';
import { getAllCompanies } from '../../../CompanyModule/shared/services/data.service';
import {
  InputText,
  InputTextErrorMode,
  InputTextType
} from '../../../shared/components/core-ui/input-text/input-text.component';

const captchaKEy = GOOGLE_CAPTCHA_KEY;
const blockDateTypeOptions = [
  { value: 'isOwnerStay', label: 'Owner stay' },
  { value: 'isMaintenance', label: 'Maintenance' },
  { value: 'other', label: 'Other' }
] as const;
type BlockDateType = typeof blockDateTypeOptions[number]['value'];
const ownerStayDescription = 'Owners Visit';
const maintenanceDescription = 'blocked for Maintenance';

export interface ReservationsCreateModalProps {
  reservationType: string;
  eventHandlers: {
    closeHandler: () => void;
  };
  openModal: boolean;
  onClose: () => void;
  unitTypeGroupsList: UnitTypeGroupUiModel[];
  allProjects: {
    label: string;
    value: string;
    areaId: string;
  }[];
  allAreas: {
    value: string;
    label: string;
    areaId: string;
  }[];
}

export const ReservationsCreateContainer: React.FC<ReservationsCreateModalProps> = ({
  reservationType,
  eventHandlers,
  openModal,
  onClose,
  unitTypeGroupsList,
  allProjects,
  allAreas
}) => {
  // const [unitType, setUnitType] = useState<UnitTypeUiModel[]>([]);
  const [selectedUnitType, SetSelectedUniType] = useState<UnitTypeUiModel>();
  const [selectedDates, setSelectedDates] = useState<Date[]>();
  const [skipEmail, setSkipEmail] = useState<boolean>(false);
  // const [skipPaymentEmail, setSkipPaymentEmail] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');
  const [blockDateType, setBlockDateType] = useState<BlockDateType>('other');
  const [proceedGuestStep, setProceedGuestStep] = useState<boolean>();
  const [bookAvailability, setBookAvailability] = useState<Date[]>([]);
  const [bookoffer, setBookoffer] = useState<BookOfferResponseModel>();
  const [selectedRoom, setSelectedRoom] = useState<string>();
  const [selectedRoomName, setSelectedRoomName] = useState<string>();
  const [selectedChannel, setSelectedChannel] = useState<ReservationChannel>(
    ReservationChannel.BIRDNEST
  );
  const [source, setSource] = useState<ReservationSource>(ReservationSource.BN_ADMIN);
  const [typeOfStay, setTypeOfStay] = useState<ReservationTypeOfStay>();
  const [companyId, setCompanyId] = useState<string>('');
  const [companiesList, setCompaniesList] = useState<CompanyUiModel[]>([]);
  const [salesPerson, setSalesPerson] = useState<UnitTypeUiModel | null>(null);
  const [guestDetails, setGuestDetails] = useState<{
    name: string;
    phoneNumber: string;
    email: string;
    gender: string;
    id: string;
  }>();
  const [canProceedAddGuest, setCanProceedAddGuest] = useState<boolean>(false);
  const addGuestProceedRef = useRef<null | (() => void)>(null);

  const [discountAmount, setDiscountAmount] = useState<number>();
  const [overRideUnitPrice, setOverRideUnitPrice] = useState<number>();
  const [discountFees, setDiscountFees] = useState<string[]>();
  const [showSalesPersonModal, setShowSalesPersonModal] = useState<boolean>(false);
  const [salesTeam, setSalesTeam] = useState<'in-direct' | 'direct'>();
  const [commission, setCommission] = useState<number | undefined>();
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [stepIndex, setStepIndex] = useState<number>(0);

  const isCreateBlockDates = reservationType === ReservationType.BLOCK_DATES;
  const isCreateReservation = reservationType === ReservationType.NORMAL_RESERVATION;

  const handleSkipEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSkipEmail(event.target.checked);
  };

  // const handleSkipPaymentEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSkipPaymentEmail(event.target.checked);
  // };

  useEffect(() => {
    getAllCompanies().then((response: CompanyUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setCompaniesList(response);
      }
    });
  }, []);

  function getAvailability(unitTypeId: string) {
    return getBookAvailability(unitTypeId).then((resp) => {
      if (!isErrorInfo(resp)) {
        const bookAvailabilityResponse = resp as BookAvailabilityResponseModel[];
        let availabeDates: Date[] = [];
        bookAvailabilityResponse.forEach((availObj) => {
          const dates = getDaysArray(availObj.from, availObj.to);
          availabeDates = [...availabeDates, ...dates];
        });
        setBookAvailability(availabeDates);
      }
    });
  }

  function handleBlockDateCreation() {
    const blockDates: CreateBlockDatesModel = {
      unitTypeId: Number(selectedUnitType?.id),
      roomId: selectedRoom || '',
      roomName: selectedRoomName || '',
      fromDate: (selectedDates && moment(selectedDates[0]).format('DD/MM/YYYY')) || '',
      toDate: (selectedDates && moment(selectedDates[1]).format('DD/MM/YYYY')) || '',
      description:
        blockDateType === 'isOwnerStay'
          ? ownerStayDescription
          : blockDateType === 'isMaintenance'
          ? maintenanceDescription
          : description,
      ...(blockDateType === 'isOwnerStay' && { isOwnerStay: true }),
      ...(blockDateType === 'isMaintenance' && { isMaintenance: true })
    };
    const promise = creatBlockDates(blockDates).then((response) => {
      if (!isErrorInfo(response)) {
        eventHandlers.closeHandler();
      }
    });
    birdToast.promise(promise, {
      errorFailedMessage: 'Failed to block dates',
      successMessage: 'Dates blocked successfully',
      loadingMessage: 'Blocking dates...',
      errorPermissionMessage: 'You do not have permission to block dates'
    });
  }

  const handleCreateReservation = async () => {
    if (isCreateReservation) {
      const reservations: CreateReservationRequestModel = {
        primaryGuestName: guestDetails?.name || '',
        phoneNumber: guestDetails?.phoneNumber || '',
        gender: guestDetails?.gender || '',
        email: guestDetails?.email || '',
        skipEmail,
        // skipPaymentEmail,
        channel: selectedChannel,
        source: source,
        typeOfStay: typeOfStay ? typeOfStay : undefined,
        companyId: companyId || undefined,
        salesPerson: salesPerson?.partnerId || '',
        unitTypeId: Number(selectedUnitType?.id),
        roomId: selectedRoom || '',
        recurringPayment: bookoffer?.recurringPayment,
        oneTimePayment: bookoffer?.oneTimePayment,
        rateCard: bookoffer?.rateCard,
        discountAmount,
        discountFees,
        checkInDate:
          selectedDates && selectedDates[0] ? moment(selectedDates[0]).format('DD/MM/YYYY') : '',
        checkOutDate:
          selectedDates && selectedDates[1] ? moment(selectedDates[1]).format('DD/MM/YYYY') : '',
        salesTeam: salesTeam,
        commission: commission
      };
      if (guestDetails?.id !== '') {
        reservations['userId'] = guestDetails?.id || '';
      }
      const rawToken = await recaptchaRef?.current?.executeAsync();
      const token: string | undefined = rawToken || undefined;
      const promise = createReservation({ ...reservations, token }).then((response) => {
        if (!isErrorInfo(response)) {
          eventHandlers.closeHandler();
        } else {
          throw response;
        }
      });
      birdToast.promise(promise, {
        errorFailedMessage: 'Failed to create reservation',
        successMessage: 'Reservation created successfully',
        loadingMessage: 'Creating reservation...',
        errorPermissionMessage: 'You do not have permission to create reservation'
      });
    }
  };
  return (
    <Modal
      isOpen={openModal}
      onClose={() => {
        onClose();
      }}
      containerClassName="lg:h-fit lg:max-h-[85vh] lg:w-[900px]"
      contentClassName="pt-2"
      headerContent={
        <div>
          {isCreateReservation && (
            <div className="text-2xl font-gilroy-bold">Create Reservation</div>
          )}
          {isCreateBlockDates && <div className="text-2xl font-gilroy-bold">Block Dates</div>}
        </div>
      }
      footerContent={
        <div className="flex items-center justify-between w-full gap-3">
          {/* Back Button */}
          <Button
            onClick={() => {
              if (proceedGuestStep) {
                setProceedGuestStep(false);
                setStepIndex(1);
                return;
              }

              if (!selectedUnitType) return;

              SetSelectedUniType(undefined);
              setStepIndex(0);
            }}
            disabled={!selectedUnitType}
            size={ButtonSize.medium}
            type={ButtonType.primaryInverted}
          >
            Back
          </Button>

          {/* Right Side Actions */}
          <div className="flex items-center gap-3">
            {/* Add Guest Step - Show proceed controls */}
            {proceedGuestStep && !guestDetails ? (
              <>
                <Button
                  onClick={eventHandlers.closeHandler}
                  tracking={{
                    action: 'close',
                    category: 'guests',
                    label: 'add-guest'
                  }}
                  size={ButtonSize.medium}
                  type={ButtonType.danger}
                >
                  Cancel
                </Button>
                <Button
                  disabled={!canProceedAddGuest}
                  onClick={() => addGuestProceedRef.current?.()}
                  tracking={{
                    action: 'submit',
                    category: 'guest',
                    label: 'add-guest'
                  }}
                  size={ButtonSize.medium}
                >
                  Proceed
                </Button>
              </>
            ) : (
              <>
                {/* Cancel Button */}
                <Button
                  onClick={eventHandlers.closeHandler}
                  tracking={{
                    action: 'close',
                    category: 'appt',
                    label: 'reservation-create'
                  }}
                  size={ButtonSize.medium}
                  type={ButtonType.danger}
                >
                  Cancel
                </Button>

                {/* Primary Action Button */}
                {isCreateBlockDates ? (
                  <Button
                    disabled={
                      !Array.isArray(selectedDates) ||
                      !selectedDates.length ||
                      !selectedRoom ||
                      !selectedRoomName ||
                      (blockDateType === 'other' && !description)
                    }
                    onClick={handleBlockDateCreation}
                    tracking={{
                      action: 'submit',
                      category: 'appt',
                      label: 'create-block-dates'
                    }}
                    size={ButtonSize.medium}
                  >
                    Block Dates
                  </Button>
                ) : proceedGuestStep ? (
                  <Button
                    disabled={
                      !selectedRoom ||
                      !typeOfStay ||
                      (typeOfStay === ReservationTypeOfStay.CORPORATES && !companyId) ||
                      ((source as any) === 'offline-sales' && !salesPerson) ||
                      ((source as any) === 'offline-sales' && !salesTeam) ||
                      ((source as any) === 'offline-sales' &&
                        (salesTeam as any) === 'in-direct' &&
                        !commission)
                    }
                    onClick={handleCreateReservation}
                    tracking={{
                      action: 'submit',
                      category: 'appt',
                      label: 'create-reservation'
                    }}
                    size={ButtonSize.medium}
                  >
                    Create Reservation
                  </Button>
                ) : (
                  <Button
                    disabled={!selectedUnitType || !selectedDates?.length}
                    onClick={() => {
                      if (isCreateReservation) {
                        setProceedGuestStep(true);
                        setGuestDetails(undefined);
                        setCanProceedAddGuest(false);
                        addGuestProceedRef.current = null;
                        setStepIndex(2);
                      }
                    }}
                    tracking={{
                      action: 'submit',
                      category: 'appt',
                      label: 'next-guest'
                    }}
                    size={ButtonSize.medium}
                  >
                    Next
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      }
    >
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-center text-base w-full space-x-4 mb-1.5">
          {(isCreateReservation
            ? ['Choose Unit', 'Choose Dates', 'Guest & Options']
            : ['Choose Unit', 'Block Dates']
          ).map((label, idx) => (
            <div key={label} className="flex items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center mr-2 ${
                  stepIndex >= idx ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-700'
                }`}
              >
                {idx + 1}
              </div>
              <div
                className={`${stepIndex >= idx ? 'text-primary-600 font-medium' : 'text-gray-600'}`}
              >
                {label}
              </div>
              {((idx !== 2 && isCreateReservation) || (idx !== 1 && !isCreateReservation)) && (
                <div
                  className={`mx-3 w-8 h-px ${stepIndex > idx ? 'bg-primary-500' : 'bg-gray-300'}`}
                />
              )}
            </div>
          ))}
        </div>
        <div className="w-full overflow-auto pb-24">
          <div className={!selectedUnitType ? 'block' : 'hidden'}>
            <ChooseUnitType
              data={{
                allAreas: allAreas,
                allProjects: allProjects,
                unitTypeGroups: unitTypeGroupsList
              }}
              eventHandlers={{
                selectedUnitType: (selectedUnit) => {
                  getAvailability(selectedUnit.id || '').then(() => {
                    SetSelectedUniType(selectedUnit);
                    setStepIndex(1);
                  });
                }
              }}
            />
          </div>

          <div className={selectedUnitType ? 'flex gap-6' : 'hidden'}>
            <div>
              {selectedUnitType && !proceedGuestStep && (
                <>
                  {selectedUnitType &&
                  selectedUnitType.ratePlans &&
                  selectedUnitType.ratePlans.length ? (
                    <div className="mb-4">
                      <div className="mb-3">
                        <div className="flex space-x-4 items-start">
                          <div className="border p-3 rounded">
                            <div className="text-sm text-gray-500">
                              <div className="text-base font-medium">
                                {selectedUnitType.reservationMode === 'monthly' ? '1' : 'Base'}
                              </div>
                              <div className="text-gray-600">
                                {selectedUnitType.reservationMode === 'monthly' ? 'month' : 'Rate'}
                              </div>
                            </div>
                            <div className="mt-2 text-lg">
                              EGP <b className="text-xl font-bold">{selectedUnitType.unitPrice}</b>
                            </div>
                            <div className="text-sm text-gray-500">
                              {selectedUnitType.reservationMode === 'monthly'
                                ? 'Monthly'
                                : 'per Night'}
                            </div>
                          </div>
                          {selectedUnitType.ratePlans.map((ratePlan) => (
                            <div className="border p-3 rounded" key={ratePlan.name}>
                              <div className="text-sm text-red-600">{`${ratePlan.amount}% off`}</div>
                              <div className="text-base font-medium">{ratePlan.name}</div>
                              <div className="mt-2 text-lg">
                                EGP{' '}
                                <b className="text-xl font-bold">
                                  {selectedUnitType
                                    ? parseInt(
                                        (
                                          (selectedUnitType.unitPrice as number) *
                                          (1 - ratePlan.amount / 100)
                                        ).toString()
                                      )
                                    : 0}
                                </b>
                              </div>
                              <div className="text-sm text-gray-500">
                                {selectedUnitType.reservationMode === 'monthly'
                                  ? 'Monthly'
                                  : 'per Night'}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <ChooseAppt
                    data={{
                      disbaleDate: bookAvailability,
                      selectedUnitType: selectedUnitType,
                      basePrice:
                        selectedUnitType.reservationMode === ReservationMode.DAILY
                          ? selectedUnitType.unitPrice
                          : undefined,
                      customPrices:
                        selectedUnitType.reservationMode === ReservationMode.DAILY
                          ? selectedUnitType.customPrices
                          : undefined,
                      reservationType: reservationType as ReservationType,
                      overRideUnitPrice: overRideUnitPrice
                    }}
                    eventHandlers={{
                      setDatesAndDiscountFees: (dates, discountAmount, discountFees) => {
                        if (Array.isArray(dates) && dates.length === 2) {
                          setSelectedDates(dates);
                          setDiscountAmount(discountAmount);
                          setDiscountFees(discountFees);
                          getBookOffer(
                            selectedUnitType.id || '',
                            moment(dates[0]).format('DD/MM/YYYY'),
                            moment(dates[1]).format('DD/MM/YYYY'),
                            discountAmount,
                            discountFees,
                            overRideUnitPrice
                          ).then((res) => {
                            if (!isErrorInfo(res)) {
                              setBookoffer(res as BookOfferResponseModel);
                            }
                          });
                        }
                      },
                      onOverRideUnitPrice: (overRidePrice) => {
                        setOverRideUnitPrice(overRidePrice);
                        getBookOffer(
                          selectedUnitType.id || '',
                          moment(selectedDates ? selectedDates[0] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          moment(selectedDates ? selectedDates[1] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          discountAmount,
                          discountFees,
                          overRidePrice
                        ).then((res) => {
                          if (!isErrorInfo(res)) {
                            setBookoffer(res as BookOfferResponseModel);
                          }
                        });
                      },
                      onClearOverRideUnitPrice: () => {
                        setOverRideUnitPrice(undefined);
                        getBookOffer(
                          selectedUnitType.id || '',
                          moment(selectedDates ? selectedDates[0] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          moment(selectedDates ? selectedDates[1] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          discountAmount,
                          discountFees,
                          undefined
                        ).then((res) => {
                          if (!isErrorInfo(res)) {
                            setBookoffer(res as BookOfferResponseModel);
                          }
                        });
                      },
                      proceedApptNextStep: (next: boolean) => {
                        if (isCreateReservation) {
                          setProceedGuestStep(next);
                          setStepIndex(2);
                        }
                      },
                      cancelHandler: eventHandlers.closeHandler
                    }}
                    blockDataComponent={
                      <>
                        <div className="mt-2">
                          Choose room
                          <Select
                            className="mb-3"
                            options={bookoffer?.availableRooms.map((room) => ({
                              label: room.shortName,
                              value: room.unitId
                            }))}
                            onChange={(
                              value: ValueType<{ value: string | undefined; label: string }, false>
                            ) => {
                              setSelectedRoom(value?.value);
                              setSelectedRoomName(value?.label);
                            }}
                          />
                          Choose type
                          <Select
                            className="mb-3"
                            options={blockDateTypeOptions.map((option) => ({
                              value: option.value,
                              label: option.label
                            }))}
                            value={blockDateTypeOptions.find(
                              (option) => option.value === blockDateType
                            )}
                            onChange={(
                              value: ValueType<{ value: BlockDateType; label: string }, false>
                            ) => {
                              const nextType = value?.value || 'other';
                              setBlockDateType(nextType);
                              if (nextType === 'isOwnerStay') {
                                setDescription(ownerStayDescription);
                              } else if (nextType === 'isMaintenance') {
                                setDescription(maintenanceDescription);
                              } else {
                                setDescription('');
                              }
                            }}
                          />
                          {blockDateType === 'other' && (
                            <div className="">
                              <span className="block">Comment</span>
                              <TextArea
                                data={{
                                  value: description,
                                  placeholder: 'Add your comment'
                                }}
                                config={{
                                  autoFocus: true,
                                  maxRows: 5,
                                  className: 'w-full'
                                }}
                                eventHandlers={{
                                  onChangeHandler: (value: string) => {
                                    setDescription(value);
                                  }
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    }
                  />
                </>
              )}
              {proceedGuestStep && !guestDetails && (
                <div>
                  <AddGuest
                    eventHandlers={{
                      addGuestHandler: (guest) => {
                        setGuestDetails(guest);
                      },
                      closeHandler: () => {
                        eventHandlers.closeHandler();
                      },
                      canProceedChange: (nextCanProceed) => {
                        setCanProceedAddGuest(nextCanProceed);
                      },
                      setProceedHandler: (handler) => {
                        addGuestProceedRef.current = handler;
                      }
                    }}
                  />
                </div>
              )}

              {guestDetails && (
                <div>
                  Choose room
                  <Select
                    className="mb-3"
                    options={bookoffer?.availableRooms.map((room) => ({
                      label: room.shortName,
                      value: room.unitId
                    }))}
                    onChange={(
                      value: ValueType<{ value: string | undefined; label: string }, false>
                    ) => {
                      setSelectedRoom(value?.value);
                      setSelectedRoomName(value?.label);
                    }}
                  />
                  {isCreateReservation && (
                    <>
                      Type of stay
                      <Select
                        className="mb-3"
                        options={Object.values(ReservationTypeOfStay)?.map((s) => ({
                          value: s,
                          label: s.replaceAll('_', ' ')?.toUpperCase()
                        }))}
                        onChange={(
                          value: ValueType<{ value: string | undefined; label: string }, false>
                        ) => {
                          const nextType =
                            (value?.value as ReservationTypeOfStay) ||
                            ReservationTypeOfStay.CORPORATES;
                          setTypeOfStay(nextType);
                          if (nextType !== ReservationTypeOfStay.CORPORATES) {
                            setCompanyId('');
                          }
                          if (nextType === ReservationTypeOfStay.BROKER) {
                            setSource('offline-sales' as ReservationSource);
                            setSalesTeam('in-direct');
                          } else {
                            setSource(ReservationSource.BN_ADMIN);
                            setSalesTeam(undefined);
                          }
                        }}
                      />
                      Select Source
                      <Select
                        className="mb-3"
                        isDisabled={typeOfStay === ReservationTypeOfStay.BROKER}
                        options={
                          [...Object.values(ReservationSource), 'offline-sales']?.map((s) => ({
                            value: s,
                            label: s.replaceAll('-', ' ')?.toUpperCase()
                          })) as unknown as any
                        }
                        value={{
                          value: source,
                          label: source.replaceAll('-', ' ').toUpperCase()
                        }}
                        onChange={(
                          value: ValueType<{ value: string | undefined; label: string }, false>
                        ) => {
                          setSalesTeam(undefined);
                          setCommission(undefined);
                          setSource(value?.value as ReservationSource);
                        }}
                      />
                      Select Channel
                      <Select
                        className="mb-3"
                        options={
                          [
                            ...Object.values(ReservationChannel),
                            'WhatsApp',
                            'CallCenter',
                            'Instagram',
                            'Messenger',
                            'Referral'
                          ].map((value) => ({
                            label: value?.toUpperCase(),
                            value: value
                          })) as unknown as any
                        }
                        defaultValue={{ value: ReservationChannel.BIRDNEST, label: 'BIRDNEST' }}
                        onChange={(
                          value: ValueType<{ value: string | undefined; label: string }, false>
                        ) => {
                          setSelectedChannel(
                            (value?.value as ReservationChannel) || ReservationChannel.BIRDNEST
                          );
                        }}
                      />
                      {typeOfStay === ReservationTypeOfStay.CORPORATES && (
                        <>
                          Company Name
                          <Select
                            className="mb-3"
                            options={
                              companiesList.map((company) => ({
                                value: company.id || '',
                                label: company.name || ''
                              })) as unknown as any
                            }
                            value={
                              companyId
                                ? ({
                                    value: companyId,
                                    label:
                                      companiesList.find((company) => company.id === companyId)
                                        ?.name || ''
                                  } as any)
                                : null
                            }
                            onChange={(
                              value: ValueType<{ value: string | undefined; label: string }, false>
                            ) => {
                              const selectedId = (value?.value || '') as string;
                              setCompanyId(selectedId);
                            }}
                            placeholder="Select company"
                            isClearable={true}
                          />
                        </>
                      )}
                      {(source as any) === 'offline-sales' && (
                        <>
                          Sales Team
                          <Select
                            value={{
                              value: salesTeam,
                              label: salesTeam?.toUpperCase() || ''
                            }}
                            className="mb-3"
                            options={['in-direct', 'direct'].map((value) => ({
                              label: value?.toUpperCase(),
                              value: value
                            }))}
                            onChange={(
                              value: ValueType<{ value: string | undefined; label: string }, false>
                            ) => {
                              if (value?.value === 'direct') {
                                setCommission(undefined);
                              }
                              setSalesTeam(
                                value?.value ? (value?.value as 'in-direct' | 'direct') : undefined
                              );
                            }}
                          />
                        </>
                      )}
                      {salesTeam === 'in-direct' && (
                        <>
                          Commission
                          <InputText
                            data={{
                              value: commission?.toString() || '',
                              errorMessage: 'Commission is required',
                              placeholder: 'Enter Commission'
                            }}
                            config={{
                              maxRows: 1,
                              autoFocus: true,
                              required: true,
                              showErrorMode: InputTextErrorMode.instant,
                              type: InputTextType.number
                            }}
                            eventHandlers={{
                              onChangeHandler: (value: string) => {
                                setCommission(Number(value));
                              }
                            }}
                          />
                        </>
                      )}
                      Sales Person
                      <div>
                        {salesPerson && (
                          <div className="flex items-center gap-3 mb-2">
                            <div>{salesPerson?.partnerUsername}</div>
                            <Button onClick={() => setSalesPerson(null)} size={ButtonSize.small}>
                              Remove
                            </Button>
                          </div>
                        )}
                      </div>
                      {!salesPerson && (
                        <Button
                          onClick={() => setShowSalesPersonModal(true)}
                          size={ButtonSize.medium}
                        >
                          Select Sales Person
                        </Button>
                      )}
                      {showSalesPersonModal && (
                        <AssignSalesPersonModal
                          config={{ showModal: showSalesPersonModal }}
                          eventHandlers={{
                            closeHandler: () => {
                              setShowSalesPersonModal(false);
                            },
                            chooseUser: (unitTypeModel: UnitTypeUiModel) => {
                              if (unitTypeModel.partnerId) {
                                setSalesPerson(unitTypeModel);
                              }
                              setShowSalesPersonModal(false);
                            }
                          }}
                        />
                      )}
                      {guestDetails && (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={skipEmail}
                                onChange={handleSkipEmailChange}
                                style={{ color: '#237c58' }}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            label="Do Not Send Confirmation Email To Guest"
                          />
                          {/* <FormControlLabel
                            control={
                              <Checkbox
                                checked={skipPaymentEmail}
                                onChange={handleSkipPaymentEmailChange}
                                style={{ color: '#237c58' }}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            label="Do Not Send Payment Links To The Guest"
                          /> */}
                        </>
                      )}
                    </>
                  )}
                  <div className="mt-4">
                    <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={captchaKEy || ''} />
                  </div>
                </div>
              )}
            </div>
            <div>
              {bookoffer && selectedUnitType && selectedDates && isCreateReservation && (
                <PaymentDetails
                  data={{
                    bookOffer: bookoffer,
                    unitType: selectedUnitType,
                    checkInDate: selectedDates[0],
                    checkOutDate: selectedDates[1],
                    guestDetails
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default connect()(ReservationsCreateContainer);

const getDaysArray = (s: any, e: any) => {
  const a: Date[] = [];
  for (const d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    a.push(new Date(d));
  }
  return a;
};
